import { render, staticRenderFns } from "./monitoringOwner.vue?vue&type=template&id=affb7526&scoped=true&"
import script from "./monitoringOwner.vue?vue&type=script&lang=js&"
export * from "./monitoringOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb7526",
  null
  
)

export default component.exports